class LogoutDialogController {

  /** @ngInject */
  constructor(private $mdDialog: angular.material.IDialogService) {

  }

  logout(){
    this.$mdDialog.hide(true);
  }
  
  cancel() {
    this.$mdDialog.hide();
  }
}

export const logoutDialog: angular.IComponentOptions = {
  template: require('./logout.dialog.html'), 
  controller: LogoutDialogController
}



// WEBPACK FOOTER //
// ./src/app/common/logout-dialog/logout-dialog.ts